<template>
	<div v-loading="loading">
		<div class="pa_look_img_list">
			<div class="cols" v-for="(item,index) in imgData" :key="index">
				<!-- <img class="img" :src="$config.img_url+item.file_path"/> -->
				<el-image class="img" :style="{height : imgHeight + 'px'}" :src="appendImg(item.file_path, 100, 100)" fit="cover"></el-image>
				<span class="del" @click="imgDelTap(index)"><i class="el-icon-close"></i></span>
			</div>
			<div class="cols" v-if="imgData.length < limit">
				<el-upload
					:action="$config.upload_img_url"
					 multiple
					accept=".jpg,.gif,.png,.jpeg"
					:data="fromData"
					:limit="limit"
                    :before-upload="beforeUpload"
					:show-file-list="false"
					:on-success="uploadSuccessTap">
					<div class="pa_look_add_btn"><i class="el-icon-plus"></i></div>
				</el-upload>
			</div>
		</div>
		<div style="line-height: 16px;">
			<span style="font-size:8px;color: #BBBBBB;">
				最多传{{limit}}张，支持JPG，PNG格式，单张图片小于{{size}}MB，<br />
				<!-- 最佳分辨率：350px*750px -->
			</span>
		</div>
	</div>
</template>

<script>
  import {appendImg} from "../../../common/js/util";

  export default {
		name:'uploadImg',
		components:{ },
		props:{
			data:{
					default: []
				},
			limit: {
					type: Number,
					default: 9
				},
			imgHeight: {
					type: Number,
					default: 0
				},
			size: { //单张图片最大限制，单位M
					type: Number,
					default: 2
				}
		},
		data() {
		  return {
			loading:false,
			imgData:[],
			fromData:{  //  上传配置
        file_source: this.$uploadServer.source(),
        file_path: this.$uploadServer.savePath('news'),
        is_rename: 1
			},
		  };
		},
		watch:{
			data(val){
				this.imgData = val
			}
		},
		mounted() {
			this.imgData = this.data;

		},
		methods:{
			appendImg(url, w = 0, h = 0){
				let _url = appendImg(url);
				let query = '';
				if(w > 0 || h > 0)
				{
					query = '?x-oss-process=image/resize';
					if(w > 0)
					{
						query = query + ',w_' + w;
					}
					if(h > 0)
					{
						query = query + ',h_' + h;
					}
				}
				return _url + query
			},
			uploadSuccessTap(response, file, fileList){
				this.loading = false;
				var jsons = JSON.parse(file.response.response).data.list[0];
				var data = {
					name:jsons.name,
					url:jsons.url,
					file_path:jsons.file_path
				};
				if (this.imgData.length < this.limit) {
					this.imgData.push(data);
					this.emitTap(this.imgData);
				}else {
					this.$message.error('已超过上传限制，最多只能上传' + this.limit + '张图片');
				}
			},
			imgDelTap(index){
				this.imgData.splice(index,1);
				this.emitTap(this.imgData);
			},
			emitTap(data){
				this.$emit('uploads',data);
			},
			beforeUpload(file) {
				this.loading = true;
				const isLt = file.size / 1024 / 1024 < this.size;
				if (!isLt) {
					this.$message.error('上传头像图片大小不能超过 '+this.size+'MB!');
					this.loading = false;
				}
				return isLt;
			}
		},
    created() {
		  // console.log(this.$uploadServer.source())
    }
  }
</script>
<style scoped lang="scss">
	@import '~scss_vars';
	.pa_look_box{background:#f8f8f8;margin:0 auto;width:320px;min-height:520px;max-width:800px;border:solid 1px #e5e5e5;}
	.pa_look_inner{background:#fff;}
	.pa_look_inner .swiper{min-height:200px;}
	.pa_look_text{
		padding:10px 15px;
		.tle{margin-bottom:5px;font-size:16px;}
		.price{color:#FF700B;}
	}
	.pa_inner_tle{line-height:40px;padding:0 15px;border-bottom:solid 1px #e5e5e5;}
</style>



// WEBPACK FOOTER //
// uploadImg.vue?e66167d8